import type { Block } from "@/mocks/content";

interface Indexed {
  block: Block;
  id: string;
}

export function indexBlocks(blocks: Block[]): Indexed[] {
  let h2Count = 0;
  return blocks.map((block) => {
    if (block.type === "h2") {
      const id = `sec-${h2Count}`;
      h2Count += 1;
      return { block, id };
    }
    return { block, id: "" };
  });
}

export function buildToc(blocks: Block[]) {
  return blocks
    .filter((b): b is { type: "h2"; text: string } => b.type === "h2")
    .map((b, i) => ({ id: `sec-${i}`, text: b.text }));
}

export default function ArticleBody({ items }: { items: Indexed[] }) {
  return (
    <div>
      {items.map((item, i) => {
        const { block, id } = item;
        if (block.type === "h2") {
          return (
            <h2
              key={i}
              id={id}
              className="font-heading text-xl md:text-2xl font-black text-foreground-950 mt-10 mb-4 scroll-mt-24"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "h3") {
          return (
            <h3
              key={i}
              className="font-heading text-lg font-bold text-foreground-900 mt-8 mb-3"
            >
              {block.text}
            </h3>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={i}
              className="my-6 pl-5 border-l-4 border-accent-500 bg-accent-50 rounded-r-md py-4 pr-4"
            >
              <p className="font-heading text-base md:text-lg text-foreground-800 leading-relaxed">
                {block.text}
              </p>
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={i} className="my-5 space-y-2.5">
              {block.items.map((it) => (
                <li key={it} className="flex items-start gap-2.5 text-base text-foreground-700 leading-relaxed">
                  <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-primary-500 mt-1">
                    <i className="ri-checkbox-circle-line text-lg" />
                  </span>
                  {it}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="text-base text-foreground-700 leading-loose mb-5">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}